var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('input',{ref:"excel-upload-input",staticClass:"excel-upload-input",attrs:{"type":"file","accept":".xlsx, .xls"},on:{"change":_vm.handleClick}}),_c('button',{staticClass:"btn primary small",on:{"click":_vm.handleUpload}},[_vm._v(" "+_vm._s(_vm.$t('config.profile.common.excelUploadButton'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }